import Api from './Api';

class Storefront {
    storefronts = {};

    fetchStorefronts = () => {
        return Api.fetch(`/api/Administrative/storefronts`)
            .then((res) => {                
                    return res;
                })
            .catch(
                this.handleError
            );
    }

    getStorefrontSettings = (storefrontNumber) => {
        return Api.fetch(`/api/Settings/Storefront/${storefrontNumber}`)
            .then((res) => {
                return res;
            })
            .catch(this.handleError);
    }

    getStorefrontTranslationLocales = (storefrontNumber) => {
        return Api.fetch(`/api/Administrative/editableLanguages/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }
    getStorefrontTranslations = (storefrontNumber, language) => {
        return Api.fetch(`/api/Administrative/translations/${storefrontNumber}/${language}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }   

    getFreightHandlingCodes = (storefrontNumber) => {
        return Api.fetch(`/api/Administrative/freightHandlingCodes/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }

    getValidFreightHandlingCodes = () => {
        return Api.fetch(`/api/Administrative/validFreightHandlingCodes`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }

    getCarrierDetails = (storefrontNumber) => {
        return Api.fetch(`/api/Administrative/carrierDetails/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }

    getNews = (storefrontNumber) => {
        return Api.fetch(`/api/Administrative/news/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }

    getWarrantyAllowances = (storefrontNumber) => {
        return Api.fetch(`/api/Administrative/warrantyAllowanceCustomers/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }

    getDashboardComponents = (storefrontNumber) => {
        return Api.fetch(`/api/Administrative/dashboardComponents/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }

    updateFreightHandlingCode= (request)=>{
        let url = '/api/Administrative/updateFreightHandlingCode';
        return  Api.fetch(url, {
            method: 'POST', body: JSON.stringify(request)
        }).then(this.handleResponse)
        .catch(this.handleError);
    }

    updateCarrierDetails = (request) => {
        let url = '/api/Administrative/updateCarrierDetails';
        return Api.fetch(url, {
            method: 'POST', body: JSON.stringify(request)
        }).then(this.handleResponse)
            .catch(this.handleError);
    }

    updateNews = (request) => {
        let url = '/api/Administrative/updateNews';
        return Api.fetch(url, {
            method: 'POST', body: JSON.stringify(request)
        }).then(this.handleResponse)
            .catch(this.handleError);
    }

    updateDashboardComponentVisibility = (request) => {
        let url = '/api/Administrative/updateDashboardComponentVisibility';
        return Api.fetch(url, {
            method: 'POST', body: JSON.stringify(request)
        }).then(this.handleResponse)
            .catch(this.handleError);
    }

    updateLabel = (request) => {
        let url = '/api/Administrative/updateLabel';
        return Api.fetch(url, {
            method: 'POST', body: JSON.stringify(request)
        }).then(this.handleResponse)
            .catch(this.handleError);
    }

    updateWarrantyAllowanceCustomer = (request) => {
        let url = '/api/Administrative/updateWarrantyAllowanceCustomer';
        return Api.fetch(url, {
            method: 'POST', body: JSON.stringify(request)
        }).then(this.handleResponse)
            .catch(this.handleError);
    }

    getAdministrationTypes = (storefrontNumber) => {
        return Api.fetch(`/api/Administrative/administrationTypes/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }
    //PIM Admin
    getPIMAttributeLabels = (storefrontNumber, language) => {
        return Api.fetch(`/api/Administrative/PIMAttributeLabels/${storefrontNumber}/${language}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }
    updatePIMAttributeLabel = (request) => {
        let url = '/api/Administrative/updatePIMAttributeLabel';
        return Api.fetch(url, {
            method: 'POST', body: JSON.stringify(request)
        }).then(this.handleResponse)
            .catch(this.handleError);
    }
    
    getStorefrontOrderQuoteStatuses = (storefrontNumber) => {
        return Api.fetch(`/api/Settings/OrderQuoteStatuses/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }

    getBranchesByStorefrontNumber = (storefrontNumber) => {
        return Api.fetch(`/api/Settings/BranchesByNumber/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }

    getBranchDetails = (storefrontNumber) => {
        return Api.fetch(`/api/Settings/BranchDetails/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }

    getDashboardSettings = (storefrontNumber) => {
        return Api.fetch(`/api/Settings/DashboardSettings/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }

    getCartSettings = (storefrontNumber) => {
        return Api.fetch(`/api/Settings/CartSettings/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }

    getSalesHistorySettings = (storefrontNumber) => {
        return Api.fetch(`/api/Settings/SalesHistorySettings/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }

    getInvoiceSettings = (storefrontNumber) => {
        return Api.fetch(`/api/Settings/InvoiceSettings/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }

    getProductSettings = (storefrontNumber) => {
        return Api.fetch(`/api/Settings/ProductSettings/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }
    getPIMProductSettings = (storefrontNumber) => {
        return Api.fetch(`/api/Settings/PIMProductSettings/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }

    getAccountSummarySettings = (storefrontNumber) => {
        return Api.fetch(`/api/Settings/AccountSummarySettings/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }

    getWarrantySettings = (storefrontNumber) => {
        return Api.fetch(`/api/Settings/WarrantySettings/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }

    getPersonas = (storefrontNumber) => {
        return Api.fetch(`/api/Settings/Personas/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }

    getSelectablePersonas = (storefrontNumber) => {
        return Api.fetch(`/api/Settings/SelectablePersonas/${storefrontNumber}`)
            .then((res) => { return res; })
            .then(this.handlerError)
    }

    getBranches = (storefrontId) => {
        return Api.fetch(`/api/Settings/Branches/${storefrontId}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }

    getUsersSettings = (storefrontNumber) => {
        return Api.fetch(`/api/Settings/UsersSettings/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }
    getWelcomeSettings = (storefrontNumber) => {
        return Api.fetch(`/api/Settings/WelcomeSettings/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }
    getProductSalesCodes = () => {
        return Api.fetch(`/api/Administrative/productSalesCodes`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }
    updateProductSalesCode = (request) => {
        let url = '/api/Administrative/updateProductSalesCode';
        return Api.fetch(url, {
            method: 'POST', body: JSON.stringify(request)
        }).then(this.handleResponse)
            .catch(this.handleError);
    }

    getNotificationBannerSettings = async (page) => {
        try {
            const res = await Api.fetch(`/api/Settings/NotificationBannerSettings/${page}`);

            return res;
        } catch (error) {
            console.log("Failed to load notification banner.");
            console.log(error);
        }
    }
    getRestrictedItems = (storefrontNumber) => {
        return Api.fetch(`/api/Administrative/restrictedItems/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }
    updateRestrictedItems = (request) => {
        let url = '/api/Administrative/updateRestrictedItems';
        return Api.fetch(url, {
            method: 'POST', body: JSON.stringify(request)
        }).then(this.handleResponse)
            .catch(this.handleError);
    } 
   
    getBrachList = (storefrontNumber) => {
        return Api.fetch(`/api/Administrative/branch/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }
    updateBranchItems = (request) => {
        let url = '/api/Administrative/updateBranch';
        return Api.fetch(url, {
            method: 'POST', body: JSON.stringify(request)
        }).then(this.handleResponse)
            .catch(this.handleError);
    } 

    getOptionalOrderTypes = (storefrontNumber) => {
        return Api.fetch(`/api/Administrative/optionalOrderType/${storefrontNumber}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }
    updateOptionalOrderType = (request) => {
        let url = '/api/Administrative/updateOptionalOrderType';
        return Api.fetch(url, {
            method: 'POST', body: JSON.stringify(request)
        }).then(this.handleResponse)
            .catch(this.handleError);
    }


    handleError = (e) => {
        console.log("Failed to load storefronts.");
        console.log(e);
    }
    handleResponse = (response) => {
        if (response) {
            return response.json();
        }
    }
}

export default new Storefront();